import { gql } from "@apollo/client";

export const GET_CURRENT_PTA_USER = gql`
query getPtaCurrentUser {
  getCurrentUser {
    nodes {
      uId
      uEmailId
      uRole
      uFullName
      uUserName
      uUserPassword
      uPhoneNumber
      uCognitoId
      
    }
  }
  schoolAdmin: allSchoolAdmins {
    nodes {
      saName
      saEmailId
      saDescription
      saAvatarUrl
      saWebsite
    }
  }
}`;

export const GET_ALL_MEETING_CATEGORIES = gql`
query getallMeetingCategories {
  allMeetingCategories(orderBy: MC_ORDER_ASC) {
    nodes {
      mcId
      mcType
      mcOriginalType
      mcTypeCapitalized
      mcDescription
      mcOrder
      mcUrl
      mcCode
      deletedAt
      createdAt
    }
  }
}`;

export const CREATE_PTA_MEETING = gql`
mutation createPtaMeeting($input: CreateMeetingInput!) {
  createPtaMeeting(input: $input)
}`;

export const GET_ALL_PTA_MEETING = gql`
query getAllMeetings($input: getMeetingInput!) {
  getAllMeetings(input: $input) {
    mId
    mStartTime
    mSessionUrl
    mTopic
    mcId
    mEndTime
    isActive
    serverUrl
    botUrl
    meetingType
  }
}`;

export const GET_PTA_MEETING_BY_ID = gql`
query getMeetingById($mId: String!) {
  getMeetingById(mId: $mId) {
    isActive
    mEndTime
    mId
    mSessionUrl
    mStartTime
    mTopic
    mcId
    mParticipantCount
    mCode
    mStatus
    hostId
    isRecordStart
    recordStartTime
    serverUrl
    botUrl
    meetingType
    participantIds
    replicaMeetingIds
    showChat
    originalHostId
    mediaPipelineId
    mediaPipelineArn
  }
}`;

export const VERIFY_GENERAL_CATEGORY = gql`
query verifyGeneralMeetingCode($mCode: String!) {
  verifyGeneralMeetingCode(mCode: $mCode)
}`;

export const VERIFY_MEETING_CATEGORY = gql`
query verifyMeetingCategoryCode($mcId: String!, $mCode: String!) {
  verifyMeetingCategoryCode(mcId: $mcId, mCode: $mCode)
}
`;

export const UPDATE_MEETING_STATUS = gql`
mutation updateMeetingCode($updateInput: MeetingPatch!, $mId: UUID!) {
  updateMeetingByMId(input: {meetingPatch: $updateInput, mId: $mId}) {
    clientMutationId
  }
}`;

export const UPDATE_MEETING_PARTICIPANT_COUNT = gql`
mutation UpdateMeetingPartcipantsCount($input: MeetingParticipantsInput!) {
  updateMeetingPartcipantsCount(input: $input)
}`;

export const GET_RECORDED_MEETING_FOR_TEACHER_AND_PTA = gql`
query allRecordedSessionsUsingmCode($mcId: UUID!, $limit: Int = null, $offset: Int = null, $searchInput: String = "%", $mcCode: String!) {
  allRecordedSessions(
    filter: {
      meetingByMId: {
        mcId: {equalTo: $mcId},
        meetingCategoryByMcId:{mcCode:{equalTo:$mcCode}}}, 
        deletedAt: {isNull: true}, 
        recordSessionType: {equalTo: PTA}, 
        topic: {likeInsensitive: $searchInput}
    }
    first: $limit
    offset: $offset
    orderBy: CREATED_AT_DESC
  ) {
    nodes {
      rsId
      topic
      recordSessionType
      cId
      sessionId
      createdAt
      savedSessionUrl
      videosPlaybacktimesByRsId {
        nodes {
          playbackTime
        }
      }
    }
  }
}`;

export const GET_RECORDED_MEETING_ADMIN_BY_CATEGORY = gql`
query allRecordedSessions($mcId: UUID!, $limit: Int = null, $offset: Int = null, $searchInput: String = "%") {
  allRecordedSessions(
    filter: {
      meetingByMId: {
        mcId: {equalTo: $mcId}, 
        meetingCategoryByMcId: {meetingsByMcIdExist: true}
      }, 
      deletedAt: {isNull: true}, 
      recordSessionType: {equalTo: PTA}, 
      topic: {likeInsensitive: $searchInput}
    }
    first: $limit
    offset: $offset
    orderBy: CREATED_AT_DESC
  ) {
    nodes {
      rsId
      topic
      recordSessionType
      cId
      sessionId
      createdAt
      savedSessionUrl
      videosPlaybacktimesByRsId {
        nodes {
          playbackTime
        }
      }
    }
  }
}`;

export const GET_RECORDED_MEETING_ADMIN_ALL_CATEGORY = gql`
query allRecordedSessions($limit: Int = null, $offset: Int = null, $searchInput: String = "%") {
  allRecordedSessions(
    filter: {
      deletedAt: {isNull: true}, 
      recordSessionType: {equalTo: PTA}, 
      topic: {likeInsensitive: $searchInput}, 
      meetingByMId: {meetingCategoryByMcId: {meetingsByMcIdExist: true}}
    }
    first: $limit
    offset: $offset
    orderBy: CREATED_AT_DESC
  ) {
    nodes {
      rsId
      topic
      recordSessionType
      cId
      sessionId
      createdAt
      savedSessionUrl
      videosPlaybacktimesByRsId {
        nodes {
          playbackTime
        }
      }
    }
  }
}`;

export const DELETE_PTA_MEETING= gql`
mutation deletePtaMeeting($mId: String!, $meetingType: MeetingType) {
  deletePtaMeeting(mId: $mId, meetingType: $meetingType)
}`;

export const EDIT_PTA_MEETING= gql`
mutation editPtaMeeting($input: UpdateMeetingByMIdInput!) {
  editPtaMeeting(input: $input)
}`;

export const CATEGORY_GENERATE_CODE= gql`
mutation editMeetingCategoryCode($input: editMeetingCategory!) {
  editMeetingCategoryCode(input: $input)
}`;

export const EDIT_CATEGORY= gql`
mutation editMeetingCategoryType($input: editMeetingCategory!) {
  editMeetingCategoryType(input: $input)
}`;

export const ADD_PARTICIPANT_MEETING = gql`
  mutation AddParticipantMeeting($mId: String!, $participantId: String!) {
    addParticipantMeeting(mId: $mId, participantId: $participantId)
  }
`;

// DELETE participant from a meeting
export const DELETE_PARTICIPANT_MEETING = gql`
  mutation DeleteParticipantMeeting($mId: String!, $participantId: String!) {
    deleteParticipantMeeting(mId: $mId, participantId: $participantId)
  }
`;
